import { IComponent, ComponentType } from './component';

export interface ITab extends IComponent {
  dockId: string;
  displayActions: boolean;
  meta: {
    displayFilter: boolean;
    displaySearch: boolean;
    isActive: boolean;
    ordering: number;
  };
}

export class Tab implements ITab {
  static index = 1;

  id: string;
  dockId: string;
  title: string;
  type: ComponentType;
  displayActions = false;
  meta = {
    displayFilter: false,
    displaySearch: false,
    isActive: false,
    ordering: 0
  };

  constructor(
    dockId: string,
    title: string,
    type: ComponentType,
    displayActions?: boolean,
    customId?: string,
    meta?: {
      displayFilter: boolean,
      displaySearch: boolean,
      isActive: boolean
      ordering: number;
    }
  ) {
    this.id = customId
      ? customId
      : new Date().getUTCMilliseconds().toString() + Tab.index++;
    this.dockId = dockId;
    this.title = title;
    this.type = type;
    this.displayActions = displayActions ? displayActions : this.displayActions;
    this.meta = meta ? meta : this.meta;
  }
}
